import { RowEditAndDelete } from 'components/icons/RowEditAndDelete';

export const columnsDataOportunidades = [
	{
		Header: ' ',
		accessor: 'CheckBox',
		disableSortBy: true,
		type: 'checkBox',
		filter: false,
	},
	{
		Header: 'Cód.',
		accessor: 'codigoOportunidade',
		type: 'number',
		optional: true,
		filter: 'includesIgnoreCase',
		hover: 'Código da Oportunidade',
	},
	{
		Header: 'Seq.',
		accessor: 'sequenciaCodigoOportunidade',
		type: 'number',
		optional: true,
		filter: 'includesIgnoreCase',
		hover: 'Sequência do Código da Oportunidade',
	},
	{
		Header: 'Competência',
		accessor: 'competencia',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Ciclo/Ano',
		accessor: 'cicloAno',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Quantidade',
		accessor: 'quantidade',
		type: 'number',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Receita Bruta',
		accessor: 'receitaBruta',
		type: 'money',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Família',
		accessor: 'familia',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Subfamília',
		accessor: 'subFamilia',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Modelo',
		accessor: 'modelo',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Produto',
		accessor: 'produto',
		type: 'relation',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Cód. Produto',
		accessor: 'codigoProduto',
		type: 'disabledCodigoProduto',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Mercado',
		accessor: 'mercado',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Canal de Venda',
		accessor: 'canalVenda',
		type: 'nullableTag',
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Força de Venda',
		accessor: 'forcaVenda',
		type: 'nullableTag',
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Zona de Venda',
		accessor: 'zonaVenda',
		type: 'nullableTag',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Membro',
		accessor: 'membro',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Razão Social',
		accessor: 'cliente',
		type: 'autocomplete',
		optional: false,
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'CNPJ/CPF/ID',
		accessor: 'cnpjCpfId',
		type: 'relation',
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Data Registro',
		accessor: 'dataRegistro',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Cód. Hierarquia',
		accessor: 'code',
		type: 'relation',
		filter: 'includesIgnoreCase',
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		filter: false,
		jsx: RowEditAndDelete,
	},
];
